export function removeNulls(obj: any, allowedNullFields: string[]): any {
  if (Array.isArray(obj)) {
    return obj.map((item) => removeNulls(item, allowedNullFields));
  } else if (obj && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([k, v]) => v !== null || allowedNullFields.includes(k))
        .map(([k, v]) => [k, removeNulls(v, allowedNullFields)]),
    );
  }
  return obj;
}
